import type { SecondarySourceOption } from '#src/types/secondary-sources.ts';

export const SECONDARY_SOURCE_OPTIONS: SecondarySourceOption[] = [
	{ flagKey: 'webSearch', settingsKey: 'webSearchEnabled' },
	{ flagKey: 'lobbyregister', settingsKey: 'lobbyregisterEnabled' },
	{ flagKey: 'fragdenstaat', settingsKey: 'fragdenstaatEnabled' },
	{ flagKey: 'abgeordnetenwatch', settingsKey: 'abgeordnetenwatchEnabled' }
];
